module.exports = __webpack_public_path__ + "static/img/logo.f92ae11.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/logo.png
// module id = fL8f
// module chunks = 47